import {useEffect, useState} from 'react';
import {luxotticaSecondPairEligible} from '@/Util/LuxotticaSecondPair';

export function useLuxotticaSecondPair(hit, colorIndex, promotion) {
    const [now, setNow] = useState(Date.now);
    const selected = field => colorIndex > 0
        ? hit?.other?.['luxottica_second_pair_' + field]?.[colorIndex - 1]
        : hit?.['luxottica_second_pair_' + field];
    const boundaries = JSON.stringify([
        promotion?.starts_at, promotion?.ends_at, selected('starts_at'), selected('ends_at'),
    ]);
    useEffect(() => {
        let timeout;
        const update = () => {
            const current = Date.now();
            const future = JSON.parse(boundaries).map(value => Number(value) * 1000)
                .filter(value => Number.isFinite(value) && value > current);
            setNow(current);
            if (future.length) {
                timeout = setTimeout(update,
                    Math.min(Math.min(...future) - current + 1, 2147483647));
            }
        };
        update();
        return () => clearTimeout(timeout);
    }, [boundaries]);
    return luxotticaSecondPairEligible(hit, colorIndex, promotion, now);
}
